import { Icon } from '@iconify/react'
import {
  IonContent, IonPage, IonCol, IonRow, IonItem, IonGrid, IonLabel, IonButton, IonCard, IonCardHeader, IonCardContent,
} from '@ionic/react'
import React from 'react'
import { useHistory } from 'react-router'
import PageHeader from '../../PageHeader'

/**
 *  ==============================
 *      App Coming soon message
 *  ==============================
 */
const InsightsHelp = () => {
  const history = useHistory()
  const handleBack = () => {
    history.push('/helpcenter')
  }
  return (
    <IonPage>
      <PageHeader title='Help Center' />
      <IonRow style={{ width: '100%' }}>
        <IonRow style={{ width: '100%' }} class='ion-justify-content-center'>
          <IonCol style={{ width: '100%', background: '#CFE5E9' }} size='12'>
            <IonRow class='ion-justify-content-start'>
              <IonLabel
                onClick={handleBack}
                style={{
                  color: '#8E151F', fontSize: '13px', fontWeight: 'bold', textAlign: 'center', paddingTop: '20px', paddingLeft: '20px',
                }}
              >
                <Icon icon='eva:arrow-ios-back-fill' color='#8e151f' width='26' height='26' />Helpcenter
              </IonLabel>
            </IonRow>

            <IonRow class='ion-justify-content-center'>
              <IonLabel style={{
                color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center', paddingTop: '30px',
              }}
              >
                Insights Help
              </IonLabel>
            </IonRow>

            <IonRow class='ion-justify-content-center' style={{ width: '100%' }}>
              <IonLabel style={{
                width: '100%', fontSize: '16px', textAlign: 'center', padding: '30px',
              }}
              >
                In this section you will find articles relating to the Tasks App
              </IonLabel>
            </IonRow>

            <IonRow justify-content-center class='ion-text-center' style={{ width: '100%' }}>

              <IonItem
                class='ion-text-center'
                style={{
                  '--background': '#CFE5E9', width: '100%', align: 'center', display: 'none',
                }}
                lines='none'
              >
                <IonLabel class='ion-text-center' style={{ width: '100%' }}>
                  <input style={{ width: '60%', align: 'center' }} />
                  <IonButton fill='clear'>
                    <Icon icon='icon-park-outline:message-search' color='#326771' size='25' />
                  </IonButton>
                </IonLabel>

              </IonItem>
            </IonRow>

          </IonCol>
        </IonRow>
      </IonRow>
      <IonGrid style={{
        width: '100%', height: '100%', marginBottom: '10px', boxShadow: '-9px -1px 7px -12px rgb(0 0 0 / 75%)',
      }}
      >
        <IonContent style={{ height: '100%', '--background': 'white' }}>
          <IonRow style={{ boxShadow: '-9px -1px 7px -12px rgb(0 0 0 / 75%)' }}>
            <IonCol style={{ width: '50%' }}>
              <IonCard style={{ height: '100%', '--background': 'white' }} routerLink='/helpcenter-insights-usemap'>
                <IonCardHeader
                  class='ion-text-center'
                  style={{
                    color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center',
                  }}
                >Using the Map - Insights
                </IonCardHeader>
                <IonItem class='ion-text-center' lines='none' style={{ '--background': 'white' }}>
                  <IonCardContent>This article outlines how to use the map controls and make your work in the Insights App more efficient.</IonCardContent>
                </IonItem>
              </IonCard>
            </IonCol>

            <IonCol style={{ width: '50%' }}>
              <IonCard style={{ height: '100%', '--background': 'white' }} routerLink='/helpcenter-insights-addinsight'>
                <IonCardHeader
                  class='ion-text-center'
                  style={{
                    color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center',
                  }}
                >Adding an Insight Report
                </IonCardHeader>
                <IonItem class='ion-text-center' lines='none' style={{ '--background': 'white' }}>
                  <IonCardContent>This article outlines how to add and submit an Insight Report.</IonCardContent>
                </IonItem>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow style={{ paddingTop: '10px' }}>
            <IonCol style={{ width: '50%' }}>
              <IonCard style={{ height: '100%', '--background': 'white' }} routerLink='/helpcenter-insights-views'>
                <IonCardHeader
                  class='ion-text-center'
                  style={{
                    color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center',
                  }}
                >Filters & Views
                </IonCardHeader>
                <IonItem class='ion-text-center' lines='none' style={{ '--background': 'white' }}>
                  <IonCardContent>This article outlines how to change views within the map and use the filter system.</IonCardContent>
                </IonItem>
              </IonCard>
            </IonCol>

            <IonCol style={{ width: '50%' }}>
              <IonCard style={{ height: '100%', '--background': 'white' }} routerLink='/helpcenter-insights-alertstates'>
                <IonCardHeader
                  class='ion-text-center'
                  style={{
                    color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center',
                  }}
                >Alert States
                </IonCardHeader>
                <IonItem class='ion-text-center' lines='none' style={{ '--background': 'white' }}>
                  <IonCardContent>This article explains what Alert States are and how they affect the map view.</IonCardContent>
                </IonItem>
              </IonCard>
            </IonCol>
          </IonRow>

          <IonRow style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <IonCol style={{ width: '50%' }}>
              <IonCard style={{ height: '100%', '--background': 'white' }} routerLink='/helpcenter-insights-addincident'>
                <IonCardHeader
                  class='ion-text-center'
                  style={{
                    color: '#8E151F', fontSize: '16px', fontWeight: 'bold', textAlign: 'center',
                  }}
                >Adding an Incident
                </IonCardHeader>
                <IonItem class='ion-text-center' lines='none' style={{ '--background': 'white' }}>
                  <IonCardContent>This article outlines how to add an incident pin to the map and submit an incident report.</IonCardContent>
                </IonItem>
              </IonCard>
            </IonCol>

            <IonCol style={{ width: '50%' }} />
          </IonRow>

        </IonContent>

      </IonGrid>
    </IonPage>
  )
}

export default InsightsHelp
